import axiosInstance from '../../Config/axiosConfig';

// GET All Notifications
export const getAffiliateNotifications = async (params) => {
  try {
    const response = await axiosInstance.get('/affiliate/notification/all/list', {
      params,
    });
    
    if (!response.data.status) {
      throw new Error('Error fetching affiliate notifications', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// GET Unread Notifications List (for navbar dropdown)
export const getAffiliateUnreadNotifications = async () => {
  try {
    const response = await axiosInstance.get('/affiliate/notification/unread/list');
    
    if (!response.data.status) {
      throw new Error('Error fetching unread notifications', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// GET Unread Count (for navbar badge)
export const getAffiliateUnreadCount = async () => {
  try {
    const response = await axiosInstance.get('/affiliate/unread/notification/count');
    
    if (!response.data.status) {
      throw new Error('Error fetching unread count', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// POST Mark All as Read
export const markAllAffiliateNotificationsAsRead = async () => {
  try {
    const response = await axiosInstance.post('/affiliate/notification/all/read');
    
    if (!response.data.status) {
      throw new Error('Error marking all notifications as read', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// POST Mark Individual as Read
export const markAffiliateNotificationAsRead = async (uuid) => {
  try {
    const response = await axiosInstance.post('/affiliate/notification/read', {
      uuid,
    });
    
    if (!response.data.status) {
      throw new Error('Error marking notification as read', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// POST Mark Individual as Unread
export const markAffiliateNotificationAsUnread = async (uuid) => {
  try {
    const response = await axiosInstance.post('/affiliate/notification/unread', {
      uuid,
    });
    
    if (!response.data.status) {
      throw new Error('Error marking notification as unread', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

